<template>
  <div class="review-likes">
    <div class="review-likes__likes-title">
      {{ title }}
    </div>
    <div class="review-likes__likes-buttons-wrap">
      <div class="review-likes__likes-button-wrap">
        <button
          @click="$emit('like')"
          class="review-likes__likes-button like">
          <f-sprite-icon :icon-link="$options.icons.like.id" />
        </button>
        <div class="review-likes__likes-counter">
          {{ likes }}
        </div>
      </div>
      <div class="review-likes__likes-button-wrap">
        <button
          @click="$emit('dislike')"
          class="review-likes__likes-button dislike">
          <f-sprite-icon :icon-link="$options.icons.dislike.id" />
        </button>
        <div class="review-likes__likes-counter">
          {{ dislikes }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import like from '@/assets/icons/like.svg';
import dislike from '@/assets/icons/dislike.svg';

export default {
  name: 'review-likes',

  icons: {
    like,
    dislike,
  },

  inject: ['adaptive'],

  props: {
    likes: {
      type: Number,
      default: 0
    },
    dislikes: {
      type: Number,
      default: 0
    },
  },

  computed: {
    title() {
      return this.adaptive.isDesktop ? 'Вам помог этот отзыв?' : 'Отзыв полезен?';
    }
  },
}
</script>

<style lang="scss">
  .review-likes {
    display: flex;
    justify-content: flex-end;

    &__likes-button {
      background: none;
      width: 20px;
      height: 20px;
      padding: 0;
      cursor: pointer;
      color: $blue_40;
      vertical-align: middle;
      margin-right: 8px;

      &:hover {
        color: $blue_hover;
      }
    }

    &__likes-title,
    &__likes-counter {
      font-size: 12px;
      line-height: 20px;
      color: $gray;
    }

    &__likes-counter {
      display: inline-block;
    }

    &__likes-buttons-wrap {
      display: flex;
    }

    &__likes-button-wrap {
      margin-left: 16px;
    }
  }
</style>